/**
 * What the credential section shows, given entitlement and whether a credential already exists.
 *
 * Mirrors the server rule exactly (UtilityPortalCredentialService.ShouldRefuseCredential): only
 * ACQUIRING a credential requires a Bill Automation subscription. A credential that already exists
 * stays editable, because the password has already been collected - refusing the rotation prevents
 * nothing and strands a working setup with a credential nobody can fix.
 *
 * Pure so the rule is testable without a DOM, and so a drift from the server rule shows up as a
 * failing test rather than as a form that silently disappears for a paying customer.
 */

/** `entitled` is null until the answer arrives; nothing is offered before then. */
export const shouldShowCredentialForm = (entitled, hasCredential) => entitled === true || !!hasCredential;

/**
 * The explanation shown in place of the form.
 *
 * Only when there is nothing to edit. Explaining "you are not subscribed" above a credential the
 * customer can still rotate would contradict the control right next to it.
 */
export const shouldShowNotEntitledNotice = (entitled, hasCredential) => entitled === false && !hasCredential;